import useMediaQuery from "../../../../hooks/useMediaQuery";
import { useTanstack } from "../../../../hooks/useTanstack";
import Skeleton from "../../../../components/ui/skeleton";
// import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SubTitle } from "../../../../components/ui/typography/subTitle";
// import { next, prev } from "../../../../assets/svgs";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/scss";
import styles from "./usefulLinks.module.scss";

export const UsefulLinks = () => {
  // const [swiper, setSwiper] = useState(null);
  // const [showPrevArrow, setShowPrevArrow] = useState(false);
  // const [showNextArrow, setShowNextArrow] = useState(true);

  // const laptopFirst = useMediaQuery(`( max-width: 1280px )`);
  const laptopSmall = useMediaQuery(`( max-width: 1099px )`);
  const mobile = useMediaQuery(`( max-width: 768px )`);

  const skeletonCount = laptopSmall ? 2 : mobile ? 1 : 3;

  const { data } = useTanstack("getWebUsefulLinks");

  // useEffect(() => {
  //   if (!laptopSmall && data?.length <= 3) {
  //     setShowNextArrow(false);
  //   } else setShowNextArrow(true);
  // }, [laptopSmall, data]);

  return (
    <div className={styles.usefulLinks}>
      <div className="container">
        <div className={styles.usefulLinks_top}>
          <SubTitle text="useful_links" />
          {/* {laptopFirst && (
            <div className={styles.usefulLinks_top_icons}>
              {showPrevArrow && (
                <div
                  className="usefulLinks-btn-prev"
                  onClick={() => swiper.slidePrev()}
                >
                  {prev.icon}{" "}
                </div>
              )}
              {showNextArrow && (
                <div
                  className="usefulLinks-btn-next"
                  onClick={() => swiper.slideNext()}
                >
                  {next.icon}
                </div>
              )}
            </div>
          )} */}
        </div>

        {!data ? (
          <Skeleton type="usefulLinks" number={skeletonCount} />
        ) : (
          <div className={styles.usefulLinks_swiper}>
            {/* {!laptopFirst && showPrevArrow && (
              <div
                className="usefulLinks-button-prev"
                onClick={() => swiper.slidePrev()}
              >
                {prev.icon}
              </div>
            )} */}
            <Swiper
              // onSwiper={(swiperInstance) => setSwiper(swiperInstance)}
              // onSlideChange={(swiper) => {
              //   setShowPrevArrow(!swiper.isBeginning);
              //   setShowNextArrow(!swiper.isEnd);
              // }}
              spaceBetween={30}
              pagination={{
                clickable: true,
              }}
              speed={1000}
              loop={false}
              modules={[Navigation]}
              navigation={true}
              className={styles.usefulLinks_row}
              updateOnWindowResize={false}
              breakpoints={{
                1100: {
                  slidesPerView: 3,
                },
                768: {
                  slidesPerView: 2,
                },
                0: {
                  slidesPerView: 1,
                },
              }}
            >
              {data?.map(({ id, img, text, url }) => {
                return (
                  <SwiperSlide key={id} title={text}>
                    <Link
                      to={url}
                      target="_blank"
                      className={styles.usefulLinks_col}
                    >
                      <div className={styles.usefulLinks_col_img}>
                        <img src={img} alt={`icon${id}`} />
                      </div>
                      <div className={styles.usefulLinks_col_context}>
                        <p>{text}</p>
                      </div>
                    </Link>
                  </SwiperSlide>
                );
              })}
            </Swiper>
            {/* {!laptopFirst && showNextArrow && (
              <div
                className="usefulLinks-button-next"
                onClick={() => swiper.slideNext()}
              >
                {next.icon}
              </div>
            )} */}
          </div>
        )}
      </div>
    </div>
  );
};
